<script setup>
import { computed, watch, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();

const loggedIn = computed(() => store.state.auth.loggedIn);
const balance = computed(() => store.state.wishes.balance);
const fetchBalance = () => store.dispatch("wishes/fetchBalance");

onMounted(fetchBalance);
watch(loggedIn, fetchBalance);
</script>

<template>
  <button
    v-if="loggedIn && balance !== null"
    type="button"
    class="flex items-center rounded-lg px-2 py-1 text-base font-bold hover:bg-secondary hover:text-white"
    :title="`You have ${balance} ${balance === 1 ? 'wish' : 'wishes'} left`"
    @click="store.dispatch('wishes/openModal', 'info')"
  >
    <img src="/logo.svg" alt="" class="mr-1.5 h-5 w-5" />
    <span>{{ balance }}</span>
    <span class="ml-1 hidden sm:inline">{{
      balance === 1 ? "wish" : "wishes"
    }}</span>
  </button>
</template>
